import { cn } from "../utils/cn"
import * as React from "react"

const BAR_COLOR = "var(--chart-2, #6366f1)"
const ShareBarListItemContext = React.createContext(null)
function useCtx(name) {
  const ctx = React.useContext(ShareBarListItemContext)
  if (!ctx) throw new Error(`\`${name}\` must be used within \`ShareBarListItem\`.`)
  return ctx
}

export function ShareBarList({ className, ...props }) {
  return <ul className={cn("relative z-10 my-auto flex w-full flex-col gap-0.5", className)} {...props} />
}

export function ShareBarListItem({ className, value, children, ...props }) {
  const clamped = Math.min(100, Math.max(0, value))
  const ctx = React.useMemo(() => ({ value: clamped }), [clamped])
  return (
    <ShareBarListItemContext.Provider value={ctx}>
      <li className={cn("group relative flex h-12 items-center gap-2 overflow-hidden px-3", className)} {...props}>
        {children}
      </li>
    </ShareBarListItemContext.Provider>
  )
}

export function ShareBarListContent({ className, ...props }) {
  return <div className={cn("z-10 flex w-full items-center justify-between gap-2 text-sm", className)} {...props} />
}

export function ShareBarListLabel({ className, ...props }) {
  return <span className={cn("text-pretty text-xs", className)} {...props} />
}

export function ShareBarListValue({ className, ...props }) {
  return <span className={cn("font-medium tabular-nums text-xs", className)} {...props} />
}

export function ShareBarListFill({ className, style, ...props }) {
  const { value } = useCtx("ShareBarListFill")
  const borderMixPercent = Math.min(100, Math.max(36, value * 1.75))
  const borderRightColor = `color-mix(in srgb, ${BAR_COLOR} ${borderMixPercent}%, transparent)`
  const backgroundImage = `linear-gradient(to right, color-mix(in srgb, ${BAR_COLOR} 4%, transparent), color-mix(in srgb, ${BAR_COLOR} 36%, transparent))`
  return (
    <div
      aria-hidden
      className={cn("pointer-events-none absolute top-0 left-0 h-full border-r-2 border-solid", className)}
      style={{ ...style, width: `${value}%`, borderRightColor, backgroundImage }}
      {...props}
    />
  )
}